import { Pipe, PipeTransform } from '@angular/core';

class FormatStringData {
  [key: string]: any
}

@Pipe({ name: 'formatString' })
export class FormatStringPipe implements PipeTransform {
  transform(value: string, data?: FormatStringData): string {
    let result = value;
    Object.keys(data).forEach(key => {
      result = result.replace('{{' + key + '}}', data[key]);
    });

    return result;
  }
}